import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { UnarchiveOwnerProps } from './UnarchiveOwner.types';

export const UnarchiveOwner = ({
  selectedOwner,
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: UnarchiveOwnerProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();

  const isDisabled = !perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <ActionButton
        type="unarchive"
        onClick={onModalOpen}
        disabled={isDisabled}
        customTooltipText={isDisabled ? formatMessage({ id: AppMessages['common.noPermissions'] }) : undefined}
      />

      <ActionModal
        header={formatMessage({ id: AppMessages['owner.unarchive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        submitButtonDisabled={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['owner.unarchive.submitButton'] })}
      >
        <>
          <ActionModal.Subtitle>
            {formatMessage({ id: AppMessages['owner.unarchive.text'] })}{' '}
            {`${selectedOwner.nazwisko || ''} ${selectedOwner.imie || ''}`}
          </ActionModal.Subtitle>

          <ActionModal.Text>{formatMessage({ id: AppMessages['owner.unarchive.confirm'] })}</ActionModal.Text>
        </>
      </ActionModal>
    </>
  );
};
